__webpack_require__.p = "/javascript-activities/pressure-points/";